import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { AutofocusDirective } from "src/app/directives/autofocus.directive";
import { DelegateLinksDirective } from "./delegateLinks.directive";
import { DetectAutofillDirective } from "./detectAutofill.directive";
import { InViewDirective } from "./inView.directive";
import { ScrollIntoViewDirective } from "./scrollIntoView.directive";

const directives = [
  AutofocusDirective,
  ScrollIntoViewDirective,
  DelegateLinksDirective,
  DetectAutofillDirective,
  InViewDirective
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  exports: directives,
  declarations: directives
})
export class DirectivesModule { }
